<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Detail.scss";

  .gauge > table{
    margin: auto!important;
  }

  .bg-light-info{
    background: #dbe8fc
  }
</style>
<template>
  <div>
        <div class="vx-row">
      <div class="w-full sm:w-auto  p-1">
        <vx-card class="p-4 pt-6 h-full flex items-center justify-center" v-if="response.percent">
          
              <GChart v-if="typeControl"
                :settings="{ packages: ['corechart', 'gauge'] }"
                type="Gauge"
                :data="data"
                :options="chartOptions"
                class="gauge"
              />
              <controlDigital v-else :nfc="true" :bluetooth="true" :value="parseInt(response.percent)"/>
              <div class="text-center mt-2">
                <img :src="getImgUrl('digital')" class="h-6 w-6 inline-block align-middle"/>
                <div class="inline-block align-middle mx-2">
                  <vs-switch v-model="typeControl" />
                </div>
                <img :src="getImgUrl('analogo')" class="h-6 w-6 inline-block align-middle"/>
              </div>
        </vx-card>
      </div>
      <div class="w-full sm:w-auto p-1">
        <vx-card class="py-4 pt-6 h-full flex items-center justify-center">
          <div class="sm:hidden">
            <div class="w-full p-2 py-4">
              <div class="text-center">{{$t('Labels.Serie')}}</div>
              <div v-if="response.serie" class="text-center font-bold text-lg">{{response.serie}}</div>
            </div>
            <div class="w-full p-2 py-4">
              <div class="text-center">{{$tc('Labels.TankLevel',0)}}</div>
              <div class="text-center" v-if="response.percent">
                <statusItem custom="justify-center" :status="getStatus(response.percent)" :percent="response.percent"/>
              </div>
            </div>
            <div class="w-full p-2 py-4">
              <div class="text-center">{{$t('Labels.Battery')}}</div>
              <div class="text-center" v-if="response.battery">
                <icon-battery-percent class="align-middle" width="25" height="25" iconColor="#000" :percent="parseFloat(response.battery)" /> <span class="align-middle">{{response.battery}} %</span>
              </div>
            </div>
            <div class="w-full p-2 py-4">
              <div class="text-center">{{$t('Labels.Liters')}}</div>
              <div v-if="response.capacity" class="text-center font-bold text-lg">{{getLiters(response.percent, response.capacity)}} de {{response.capacity}}</div>
            </div>
            <div class="w-full p-2 py-4">
              <div class="text-center">{{$t('Labels.Signal')}}</div>
              <div class="text-center" v-if="response.rssi">
                <icon-signal-percent class="align-middle" width="25" height="25" iconColor="#000" :percent="getSignalPercent(response.rssi)" /> <span class="align-middle">{{getSignalPercent(response.rssi)}}%</span>
              </div>
            </div>
          </div>

          <table class="w-full hidden sm:block" >
            <tr>
              <td class="p-2 py-4" colspan="2">
                <div class="text-center">{{$t('Labels.Serie')}}</div>
                <div v-if="response.serie" class="text-center font-bold text-lg">{{response.serie}}</div>
              </td>
            </tr>
            <tr>
              <td class="p-2 py-4">
                <div class="text-center">{{$tc('Labels.TankLevel',0)}}</div>
                <div class="text-center" v-if="response.percent">
                  <statusItem custom="justify-center" :status="getStatus(response.percent)" :percent="response.percent"/>
                </div>
              </td>
              <td class="p-2 py-4">
                <div class="text-center">{{$t('Labels.Battery')}}</div>
                <div  v-if="response.battery">
                  <icon-battery-percent class="align-middle" width="25" height="25" iconColor="#000" :percent="parseFloat(response.battery)" /> <span class="align-middle">{{response.battery}} %</span>
                </div>
              </td>
            </tr>
            <tr>
            <tr>
              <td class="p-2 py-4">
                <div class="text-center">{{$t('Labels.Liters')}}</div>
                <div v-if="response.capacity" class="text-center font-bold text-lg">{{getLiters(response.percent, response.capacity)}} de {{response.capacity}}</div>
              </td>
              <td class="p-2 py-4">
                <div class="text-center">{{$t('Labels.Signal')}}</div>
                <div v-if="response.rssi">
                  <icon-signal-percent class="align-middle" width="25" height="25" iconColor="#000" :percent="getSignalPercent(response.rssi)" /> <span class="align-middle">{{getSignalPercent(response.rssi)}}%</span>
                </div>
              </td>
            </tr>
          </table>
        </vx-card>
      </div>
      <div class="flex-grow  p-1">
        <vx-card class="pb-2 h-full">
          <div class="sm:hidden">
            <div class="w-full py-2">
              <div class="text-center">{{$t('Labels.ClientNumber')}}</div>
              <div class="text-center font-bold text-lg">{{response.client_number || '--'}}</div>
            </div>
            <div class="w-full py-2">
              <div class="text-center">{{$t('Labels.ContactNumber')}}</div>
              <div class="text-center font-bold text-lg">{{client.contact_phone  | VMask('###-###-##-##') || '--'}}</div>
            </div>
            <div class="w-full py-2">
              <div class="text-center">{{$t('Labels.Address')}}</div>
              <div class="text-center font-bold text-lg">{{response.address || '--'}}</div>
            </div>
            <div class="w-full py-2">
              <div class="text-center">{{$t('Labels.PostalCode')}}</div>
              <div class="text-center font-bold text-lg">{{response.zip_code || '--'}}</div>
            </div>
            <div class="w-full py-2">
              <div class="map-container m-2" v-if="status_mapa">
                <l-map :center="center" :zoom="zoom" v-if="response" :options="{zoomControl: false }">
                    <l-tile-layer :attribution="attribution" :url="url">
                    </l-tile-layer>
                    <l-marker :lat-lng="marker" ref="position_marker">
                        <l-icon :icon-anchor="staticAnchor">
                            <img :src="require(`@/assets/images/markers/0.svg`)" width="25px;"/>
                        </l-icon>
                    </l-marker>
                </l-map>
              </div>
            </div>
          </div>
          <table class="w-full table-details radius hidden sm:table">
            <thead>
              <th colspan="3">
                {{$t('Labels.DeviceInformation')}}
                <feather-icon v-if="!editClient"  @click="editClient = true" icon="EditIcon" svgClasses="h-5 w-5 text-grey-ligth" class="float-right cursor-pointer hover:text-primary"/>
                <feather-icon v-if="editClient" @click="editClient = false" icon="XIcon" svgClasses="h-5 w-5 text-grey-ligth" class="float-right cursor-pointer hover:text-primary"/>
                <feather-icon v-if="editClient" @click="updateClient()" icon="SaveIcon" svgClasses="h-5 w-5 text-grey-ligth" class="float-right cursor-pointer hover:text-primary"/>    
              </th>
            </thead>
            <tbody>
              <tr>
                <listItem
                  class="px-5"
                  :value="client.client_number || '--'"
                  :description="$t('Labels.ClientNumber')"
                ></listItem>
                <listItem 
                  class="px-5"
                  v-if="!editClient"
                  :value="client.contact_phone  | VMask('###-###-##-##') || '--'"
                  :description="$t('Labels.ContactNumber')"
                ></listItem>
                <td v-if="editClient">
                  <vs-input  class="" :label="$t('Labels.ContactNumber')" type="text" v-model="clientEditor.contact_phone"  v-mask="'###-###-##-##'" />         
                </td>
                <td rowspan="5" width="50%">
                  <div v-if="!status_mapa" class="map-container text-center h-full">{{$t('Labels.NoData')}}</div>
                  <div class="map-container m-2" v-if="status_mapa">
                    <l-map :center="center" :zoom="zoom" v-if="response" :options="{zoomControl: false }">
                        <l-tile-layer :attribution="attribution" :url="url">
                        </l-tile-layer>
                        <l-marker :lat-lng="marker" ref="position_marker">
                            <l-icon :icon-anchor="staticAnchor">
                                <img :src="require(`@/assets/images/markers/0.svg`)" width="25px;"/>
                            </l-icon>
                        </l-marker>
                    </l-map>
                  </div>
                </td>
              </tr>
              <tr>
                <listItem
                  colspan="2"
                  class="px-5"
                  :value="response.address || '--'"
                  :description="$t('Labels.Address')"
                ></listItem>
              </tr>
              <tr>
                <listItem
                  colspan="2"
                  class="px-5"
                  :value="response.zip_code || '--'"
                  :description="$t('Labels.PostalCode')"
                ></listItem>
              </tr>
            </tbody>
          </table>
        </vx-card>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full my-2">
        <vs-button  @click="showFilters = !showFilters"  type="flat" color="grey" class="float-right">
          <iconBase iconName="filter_asc" :width="18" :height="18" iconColor="#626262" class="align-middle mr-2"><iconFilter/></iconBase>
          <span v-show="!showFilters"  class="font-bold">{{$t('Labels.ShowFilters')}}</span>
          <span v-show="showFilters"  class="font-bold">{{$t('Labels.HideFilters')}}</span>
        </vs-button>
      </div>
    </div>
    <div class="vx-row px-2 py-5" v-show="showFilters">
      <div class="vx-col w-full  sm:w-auto ">
        <vs-checkbox v-model="filterDates" class="inline-block"></vs-checkbox>
        <label class="font-bold">{{$t('Labels.From')}}</label>
        <datepicker :value="filters.begin_date" v-model="filters.begin_date" format="dd-MM-yyyy" :disabled="!filterDates"></datepicker>
      </div>
      <div class="vx-col w-full pt-1 sm:w-auto ">
        <label class="font-bold">{{$t('Labels.To')}}</label>
        <datepicker :value="filters.end_date" v-model="filters.end_date" format="dd-MM-yyyy" :disabled="!filterDates"></datepicker>
      </div>
      <div class="vx-col w-full text-center sm:w-auto">
        <vs-button @click="getHistory()" color="primary" class="mr-2 mt-6">{{$t('Labels.Filter')}}</vs-button>
      </div>
    </div>
    <div class="vx-row mb-5">
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <label class="font-bold align-middle mr-2">{{$t('Labels.OrderBy')}}</label><v-select @input="getHistory" class="align-middle inline-block" :options="columnOrders" v-model="filters.byColumn" :reduce="v => v.value"/>
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <vs-button size="small" @click="filterOrders('ASC')"  type="flat" color="grey" class="align-middle inline-block ml-2" :class="{'bg-primary': filters.byOrder == 'ASC'}">
          <iconBase iconName="filter_asc" :width="18" :height="18" iconColor="#626262" class="align-middle"><iconFilterAsc/></iconBase>
        </vs-button>
        <vs-button  size="small" @click="filterOrders('DESC')"  type="flat" color="grey" class="align-middle inline-block ml-2" :class="{'bg-primary': filters.byOrder != 'ASC'}">
          <iconBase iconName="filter_desc" :width="18" :height="18" iconColor="#626262" class="align-middle"><iconFilterDesc/></iconBase>
        </vs-button> 
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <label class="font-bold align-middle mr-2">{{$t('Labels.ByPage')}}</label><v-select @input="getHistory" class="align-middle inline-block" :options="byPage" v-model="filters.limit" :reduce="v => v.value"/> 
      </div>
    </div>
    <div class="vx-row">
      <div class="w-full">
        <vs-table  v-if="history" :data="history">
          <template slot="thead">
            <vs-th>
              {{$tc('Labels.TankLevel',1)}}
            </vs-th>
            <vs-th>
              {{$t('Labels.Liters')}}
            </vs-th>
            <vs-th>
              {{$t('Labels.Battery')}}
            </vs-th>
            <vs-th>
              {{$t('Labels.Date')}}
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :data="item" :key="index" v-for="(item, index) in data" :class="item.tipo === 'R' ? 'bg-light-info' : ''">
              <vs-td :data="parseInt(item.percent)">
                <statusItem :status="item.createdAt.length > 0 ? getStatus(item.percent) : 'grey'" :percent="item.percent"/>
              </vs-td>
              <vs-td :data="getLiters(item.percent,item.capacity)">
                {{getLiters(item.percent, response.capacity)}} / {{response.capacity}}
              </vs-td>
              <vs-td :data="item.battery" >
                <icon-battery-percent class="align-middle" width="25" height="25" iconColor="#000" :percent="parseFloat(item.battery)" /> <span class="align-middle">{{item.battery}} %</span>
              </vs-td>
              <vs-td :data="item.createdAt" class="text-center">
                <span>
                  {{item.createdAt.length > 0 ? relativeTimeConvert(item.createdAt) : $t('Labels.Inactive')}}
                  <div v-if="item.tipo === 'R'">
                    <feather-icon
                    icon="ArrowUpCircleIcon"
                    class="p-2"/>
                    <b>{{$t('Labels.LastChargeGas')}}</b>
                  </div>
                </span>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <vs-pagination class="mt-5" v-if="history" :max="3" :total="totalPages" v-model="currentx"></vs-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import {request} from '@/request.js'
import statusItem from '@/components/statusItem/statusItem.vue'
import listItem from '@/components/listItem/listItem.vue'
import { GChart } from 'vue-google-charts'
import controlDigital from '@/components/controlDigital/controlDigital.vue'
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon
} from 'vue2-leaflet'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'
import 'leaflet/dist/leaflet.css'
import {getStatusByPercent, getSignalPercent, formatDate} from '@/helpers.js'
import iconBatteryPercent from '@/components/icons/iconBatteryPercent'
import iconSignalPercent from '@/components/icons/iconSignalPercent'
import Datepicker from 'vuejs-datepicker'
import vSelect from 'vue-select'
import iconBase from '@/components/icons/iconBase'
import iconFilterAsc from '@/components/icons/iconFilterAsc'
import iconFilterDesc from '@/components/icons/iconFilterDesc'
import iconFilter from '@/components/icons/iconFilter'
import L from 'leaflet'

export default {
  components: {
    statusItem,
    listItem,
    GChart,
    controlDigital,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    iconBatteryPercent,
    iconSignalPercent,
    Datepicker,
    'v-select': vSelect,
    iconFilterDesc,
    iconFilterAsc,
    iconBase,
    iconFilter
  },
  data () {
    return {
      response: [],
      history:[],
      client:{},
      uuid: this.$route.params.uuid,
      typeControl: false,
      chartOptions: {
        width: 120,
        height: 120,
        redFrom: 90,
        redTo: 100,
        yellowFrom:0,
        yellowTo: 20,
        majorTicks: ['0', '20', '40', '60', '80', '100'],
        max: 100,
        min: 0
      },
      data: [
        ['Label', 'Value'],
        ['GAS', 0]
      ],
      zoom:17,
      center: L.latLng(47.41322, -1.219482),
      url:'https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png',
      attribution:'',
      marker: L.latLng(47.41322, -1.219482),
      staticAnchor: [12, 27],
      icon_marker: [],
      status_mapa: false,
      editDevice: false,
      editClient: false,
      chartConsume: false,
      chartWeek: false,
      chartRecharge: false,
      clientEditor: {},
      deviceEditor: {},
      filters:{
        limit: 20,
        offset: 0,
        byColumn: 'createdAt',
        byOrder: 'DESC',
        begin_date: new Date(),
        end_date: new Date()
      },
      currentx: 1,
      totalPages: 0,
      columnOrders:[
        {label: this.$tc('Labels.TankLevel', 1), value: 'percent'},
        {label: this.$t('Labels.Battery'), value: 'battery'},
        {label: this.$t('Labels.Date'), value: 'createdAt'}
      ],
      filterDates: false,
      byPage:[
        {label: 20, value: 20},
        {label: 50, value: 50},
        {label: 75, value: 75},
        {label: 100, value: 100}
      ],
      showFilters: false
    }
  },

  methods: {
    async getResponse () {
      const params = {
        url: `gas_devices/${this.uuid}`,
        method: 'GET'
      }
      await request(params).then(response => {
        this.response = response.data.data
        this.client.address = this.response.address
        this.client.client_number = this.response.client_number
        this.client.zip_code = this.response.zip_code
        this.client.contact_phone = this.response.contact_phone
        
        this.deviceEditor.name = this.response.name
        this.data[1][1] = parseFloat(this.response.percent)
        if (this.response.latlong.length > 0) {
          const location = this.response.latlong.split(',')
          this.marker = L.latLng(location[0], location[1])
          this.center = L.latLng(location[0], location[1])
          this.status_mapa = true
        }

      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    async getHistory () {
      const filter = {}
      filter.limit = this.filters.limit
      filter.offset = this.filters.offset
      filter.byColumn = this.filters.byColumn
      filter.byOrder = this.filters.byOrder

      if (this.filterDates) {
        console.log(this.filters.begin_date)
        filter.begin_date = formatDate(this.filters.begin_date)
        filter.end_date = formatDate(this.filters.end_date)
      }

      const params = {
        url: `gas_devices/${this.uuid}/historic`,
        method: 'GET',
        params: filter
      }
      await request(params).then(response => {
        this.history = response.data.data.rows
        this.setPages(response.data.data.count)
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    getImgUrl (name) {
      const images = require.context('@/assets/images/icons/', false, /\.svg$/)
      return images(`./${  name  }.svg`)
    },
    getStatus (percent) {
      return getStatusByPercent(percent)
    },
    getLiters (percent, capacity) {
      return  (capacity * (percent / 100)).toFixed(2)
    },
    getSignalPercent (value) {
      return getSignalPercent(value)
    },
    relativeTimeConvert (date) {
      return this.$dayjs().to(this.$dayjs(date))
    },
    setPages (total) {
      this.totalPages = Math.ceil(total / this.filters.limit)
    },
    filterOrders (param) {
      this.filters.byOrder = param
      this.getHistory()
    }
  },
  created () {
    screen.width < '576' ? this.showFilters = false : this.showFilters = true
    this.getResponse()
    this.getHistory()
  },
  watch: {
    currentx (val) {
      this.filters.offset = (val - 1) * this.filters.limit
      this.getHistory()
    },
    byColumn (val) {
      this.filters.byColumn = val
      this.currentx = 1
    }
  }
}
</script>